import React from 'react';

import { StyledIcon } from '../StyledIcon';

export const DocumentThreat = props => (
  <StyledIcon viewBox='0 0 24 24' a11yTitle='DocumentThreat' {...props}>
    <path fill='none' stroke='#000' strokeWidth='2' d='M4.99787498,6.99999999 L4.99787498,0.999999992 L19.4999998,0.999999992 L22.9999998,4.50000005 L23,23 L17,23 M18,1 L18,6 L23,6 M9,23 C11.7614237,23 14,20.7614237 14,18 C14,15.2385763 11.7614237,13 9,13 C6.23857625,13 4,15.2385763 4,18 C4,20.7614237 6.23857625,23 9,23 Z M9,11 C9,11 9,10 9,9 C9,8 9,7 11,7 C13,7 13.0000001,8 13,9 C12.9999999,10 13,10.9999998 15,10.9999999 C17,11.0000001 17,11 17,11 M8,11 L10,11 L10,13 L8,13 L8,11 Z' />
  </StyledIcon>
);
